import { Component, effect, ViewChild, inject } from '@angular/core';
import { ServiceSettingsVoucherStore } from './service-settings-voucher.store';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { SERVICE_SETTINGS_VOUCHER_TYPE_KEY } from '@libs/types/src/services/types/service-settings-voucher.type';
import { contentGlobalSuccess } from '../../../../content.error';
import { ActivatedRoute, Router } from '@angular/router';
import { Divider } from '@openng/optimus-ui/divider';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-settings-voucher',
    templateUrl: './service-settings-voucher.component.html',
    providers: [ServiceSettingsVoucherStore],
    imports: [
        ServiceSettingsCommonComponent,
        Divider,
        CheckInputComponent,
        TextInputComponent,
        ActionButtonsComponent,
    ],
})
export class ServiceSettingsVoucherComponent {
    protected readonly store = inject(ServiceSettingsVoucherStore);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);


    @ViewChild(ServiceSettingsCommonComponent) serviceSettingsCommonComponent!: ServiceSettingsCommonComponent;

    form = fb.group({
        usePlanAndEvaluation: fb.control<boolean>(true),
        emailToUserWhenVoucherChanges: fb.control<string | null>(null),
    });

    constructor() {
        effect(() => {
            const defaultValues = this.store.voucherSettings();
            if (defaultValues) {
                this.form.patchValue({
                    usePlanAndEvaluation: defaultValues?.usePlanAndEvaluation ?? true,
                    emailToUserWhenVoucherChanges: defaultValues?.emailToUserWhenVoucherChanges || null,
                });
            }
        });
    }

    save() {
        const serviceId = routeParams.serviceId();
        if (!serviceId) return;

        const data = {
            ...JSON.parse(this.serviceSettingsCommonComponent.getFormData()),
            usePlanAndEvaluation: Boolean(this.form.value.usePlanAndEvaluation),
            emailToUserWhenVoucherChanges: this.form.value.emailToUserWhenVoucherChanges || null,
        };

        this.store.api.updateServiceSettings({
            key: SERVICE_SETTINGS_VOUCHER_TYPE_KEY,
            data: JSON.stringify(data),
            serviceId: Number(serviceId),
        }).then(() => {
            contentGlobalSuccess.next('common.updated');
        });
    }

    async cancel() {
        this.router.navigate(['../../basic-information'], { relativeTo: this.route });
    }

}
